import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { setAuthToken } from '../lib/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');
        
        if (!sessionId) {
          // No session_id found - redirect to landing
          navigate('/', { replace: true });
          return;
        }
        
        // Exchange session_id for session_token
        
        // Exchange session_id for session_token
        const response = await api.post('/auth/session', { session_id: sessionId });
        
        const userData = response.data;
        
        if (!userData?.user_id) {
          // Invalid user data - redirect to landing
          navigate('/', { replace: true });
          return;
        }
        
        // Store token in localStorage for Safari iOS compatibility
        if (userData.token) {
          setAuthToken(userData.token);
        }
        
        // Remove token from user object before passing to state
        const { token, ...user } = userData;
        
        // Check if profile is complete - if not, redirect to profile setup
        if (!userData.profile_complete) {
          window.history.replaceState({}, document.title, '/profile-setup');
          navigate('/profile-setup', { state: { user }, replace: true });
          return;
        }
        
        // Profile is complete - go to main app
        window.history.replaceState({}, document.title, '/tv-shows');
        navigate('/tv-shows', { state: { user }, replace: true });
        
      } catch (error) {
        // Auth failed - clear token and redirect
        setAuthToken(null);
        navigate('/', { replace: true });
      }
    };
    
    processAuth();
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#F87171] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#3D4F6F] font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
